
















































































































































































































































import { RegisterVue } from "fs-pb-vue2/vueModels/auth/RegisterVue";
import { Component } from "vue-property-decorator";
import { RegisterModel } from "fs-pb-vue2/models/auth/RegisterModel";
import i18n from "@/i18n";

@Component({})
export default class Register extends RegisterVue {
  showConfirmationModal: boolean = false;
  confirmationAccepted: boolean = false;
  checkbox1: boolean = false;
  checkbox2: boolean = false;
  acceptHtml: string = "";

  async mounted() {
    await this.init();

    try {
      const response = await fetch(this.acceptFile);
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }
      this.acceptHtml = await response.text();
    } catch (e) {
      console.error("Ошибка загрузки текста из acceptText:", e);
    }
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.loginDialogContent = i18n.t("auth.messages.successregister", { login: (this.OperationModel as RegisterModel).Phone }).toString();;
    this.loginDialog = true;
  }  

  nextStepProxy(): void {
    if (this.confirmationAccepted) {
      this.next();
      return;
    }

    this.validateForm();

    if (this.isValid) {
      this.showConfirmationModal = true;
    } else {
      this.scrollToTop();
    }
  }

  submitFinal(): void {
    this.confirmationAccepted = true;
    this.showConfirmationModal = false;

    this.$nextTick(() => {
      this.next();
    });
  }

  cancelModal(): void {
    this.confirmationAccepted = false;
    this.showConfirmationModal = false;
  }
}
